import { useTranslation } from '../../i18n/i18n';
import { ApiProduct } from '../../types';
import { renderTemplate } from '../utils';

type StockKeepingMessageProps = { product: ApiProduct };
export function StockKeepingMessage({
	product: { quantityInStock, deliveryClass },
}: StockKeepingMessageProps): JSX.Element {
	const t = useTranslation().product;

	function stockText() {
		if (quantityInStock <= 0 || deliveryClass === 6) return t.noneInStock;
		if (quantityInStock > 1000)
			return renderTemplate(t.inStock, {
				quantity: 1000 * Math.floor(quantityInStock / 1000),
			});
		for (var level of [500, 200, 100, 50, 20, 10])
			if (quantityInStock > level) return renderTemplate(t.inStock, { quantity: level });
		return renderTemplate(t.fewInStock, { quantity: 10 });
	}

	return <>{stockText()}</>;
}
